import {Dialog,DialogTitle,DialogContent,DialogActions,Button,Typography} from '@mui/material';
import {useApplication} from './ApplicationContext.js';

export default function SessionExpiryDialog({showSessionWarning,sessionExpiresAt,onRenew,onDismiss}){
    const {globalData}=useApplication();
    const gl=(key,fallback)=>globalData?.getLocale(key)||fallback;

    if(!showSessionWarning||!sessionExpiresAt) return null;

    const alreadyExpired=Date.now()>sessionExpiresAt;
    const formattedTime=new Date(sessionExpiresAt).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});

    const title=alreadyExpired
        ?gl('SessionExpiredTitle','Session has expired')
        :gl('SessionExpiringSoonTitle','Session expiring soon');

    const bodyMain=(alreadyExpired
        ?gl('SessionExpiredBody','Your session expired at {TIME}. Log in again to continue.')
        :gl('SessionExpiringSoonBody','Your session will expire at {TIME}.')
    ).replace('{TIME}',formattedTime);

    return(
        <Dialog open={showSessionWarning} disableEscapeKeyDown>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography gutterBottom>{bodyMain}</Typography>
                {!alreadyExpired&&(
                    <Typography variant="body2" color="text.secondary">
                        {gl('SessionExpiringSoonBodySub','Save any unsaved work, then click Renew Session. The page will briefly reload to issue a fresh session.')}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                {!alreadyExpired&&(
                    <Button onClick={onDismiss} color="inherit">
                        {gl('ButtonDismiss','Dismiss')}
                    </Button>
                )}
                <Button onClick={onRenew} variant="contained" color="primary">
                    {gl('ButtonRenewSession','Renew Session')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
